import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageCircle } from 'lucide-react';

const FloatingActions = () => {
    const phoneNumber = "0712345678";
    const whatsappLink = `https://wa.me/${phoneNumber.replace(/^0/, '254')}`; // Format for Kenyan international code

    return (
        <>
            {/* LEFT SIDE: WhatsApp (Visible on All Devices) */}
            <motion.div 
                initial={{ x: -100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                whileHover={{ scale: 1.1 }}
                className="fixed bottom-8 left-6 z-[90]"
            >
                <a 
                    href={whatsappLink} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="flex items-center gap-3 bg-green-500 text-white p-4 rounded-full shadow-2xl shadow-green-500/40 border-2 border-white/20 backdrop-blur-md"
                >
                    <MessageCircle size={24} fill="currentColor" />
                    <span className="hidden md:block font-black text-sm tracking-tighter">WHATSAPP US</span>
                </a>
            </motion.div>

            {/* RIGHT SIDE: Call Button (Visible ONLY on Mobile/Phone View) */}
            <motion.div 
                initial={{ x: 100, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                whileHover={{ scale: 1.1 }}
                /* md:hidden ensures it vanishes on desktop/tablets */
                className="fixed bottom-8 right-6 z-[90] md:hidden"
            >
                <a 
                    href={`tel:${phoneNumber}`} 
                    className="flex items-center gap-3 bg-red-600 text-white p-4 rounded-full shadow-2xl shadow-red-600/40 border-2 border-white/20 backdrop-blur-md animate-bounce"
                >
                    <Phone size={24} fill="currentColor" />
                    <span className="font-black text-sm tracking-tighter uppercase">Call Us</span>
                </a>
            </motion.div>
        </>
    );
};

export default FloatingActions;